<section class="section banner">
    <div [@bannerTrigger] class="container">
        <div class="section-box-banner">
            <div class="content">
                <div>
                    <!-- <h1>Hola, mi nombre es</h1> -->
                    <h1>Hello! My name is</h1>
                </div>
                <div class='banner-title'>
                    <h2 class="text-capitalize">loay elden gamal.</h2>
                    <h3 class="text-capitalize">front-end developer</h3>
                </div>
                <div class='banner-description'>
                    <p  class="mt-4">I have  <span class="underline"> 2 years of experience </span> developing systems, interfaces, bots, and technological solutions to make the web a better place. I am dedicated to writing and refactoring clean, reusable, and scalable code in <span class="underline"> Angular, javascript ,typescript</span>  applying good practices and development standards.</p>
                </div>
            </div>
            <div class="div-btn-banner">
                <a (click)='analyticsService.sendAnalyticEvent("click_send_mail", "banner", "email")' href="loayeldin123@gmail.com" target="_black" class="main-btn text-capitalize">
                    get in touch
                </a>
            </div>
        </div>
    </div>
</section>
